import axios from "axios";
import API from "../helpers/api";

export const getContractCount = (statusId) => {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let url = `${API.GetContractCount}?email=${user.email}&statusId=${statusId}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "GetContractCountSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: "GetContractCountFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getContractTypeOptions = () => {
    let url = `${API.equipmentLookups}?lookupType=${"contract type"}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "GetContractTypeSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                // dispatch({
                //     type: "GetContractCountFailure",
                //     error: "ERROR"
                // })
            })
    }
}

export const getPlanTypeOptions = (id) => {
    let url = `${API.equipmentLookups}?lookupType=${"plan type"}&parentId=${id}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "GetPlanTypeSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                // dispatch({
                //     type: "GetContractCountFailure",
                //     error: "ERROR"
                // })
            })
    }
}

export const getBillingTypeOptions = () => {
    let url = `${API.equipmentLookups}?lookupType=${"billing type"}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "GetBillingTypeSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                // dispatch({
                //     type: "GetContractCountFailure",
                //     error: "ERROR"
                // })
            })
    }
}

export const getContractStatusOptions = () => {
    let url = `${API.equipmentLookups}?lookupType=${"contract status"}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "GetContractStatusSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                // dispatch({
                //     type: "GetContractCountFailure",
                //     error: "ERROR"
                // })
            })
    }
}

export const getShipOptions = () => {
    let url = `${API.equipmentLookups}?lookupType=${"ship"}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "GetShipIdNameSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                // dispatch({
                //     type: "GetContractCountFailure",
                //     error: "ERROR"
                // })
            })
    }
}

export const getContractDeatil = (contractId) => {
    let url = `${API.MMPLGetContractDetail}?mmplShipContractId=${contractId}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "GetContractDetailSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: "GetContractDetailFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getContractSearchlist = (searchItem) => {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    // let url = `${API.MMPLGetContractSearch}?overDue=${searchItem.overDue}&dueIn30Days=${searchItem.dueIn30Days}&ContractName=${searchItem.ContractName}&ShipName=${searchItem.ShipName}&clientName=${searchItem.clientName}&ImoNo=${searchItem.ImoNo}&status=${searchItem.status}&startdate=${searchItem.startdate}&expiryDate=${searchItem.expiryDate}&PageNumber=${searchItem.PageNumber}&PageSize=${searchItem.PageSize}`;
    let url = `${API.MMPLGetContractSearch}?email=${user.email}`;
    return dispatch => {
        dispatch({
            type: "MDSearchIsTrue",
            data: searchItem
        })
        axios.post(url, searchItem)
            .then((response) => {
                dispatch({
                    type: "GetContractSearchSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "GetContractSearchFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getContractHistory = (id) => {
    let url = `${API.GetContractHistory}?contractId=${id}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "GetContractHistorySuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: "GetContractHistoryFailure",
                    error: "ERROR"
                })
            })
    }
}

export const putContractDeatil = (data) => {

    let url = `${API.PostContractDetails}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                dispatch({
                    type: "PutContractDetailSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: "PutContractDetailFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getContractShipList = () => {
    let url = `${API.GetContractShipList}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "GetContractShipListSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: "GetContractShipListFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getContractClientName = (shipName) => {
    let url = `${API.GetContractClientName}?ShipName=${shipName}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "GetContractClientNameSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: "GetContractClientNameFailure",
                    error: "ERROR"
                })
            })
    }
}

export const postContractDeatil = (data) => {
    let url = `${API.PostContractDetails}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                dispatch({
                    type: "PostContractDetailSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: "PostContractDetailFailure",
                    error: "ERROR"
                })
            })
    }
}
export const getClientIMONO = (shipName) => {
    let url = `${API.clientIMONo}?shipName=${shipName}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getClientIMONOSuccess",
                    data: response.data
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getClientIMONOFailure",
                    error: "ERROR"
                })
            })
    }
}
